// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"9d18297d","467":"4458cda7","657":"5ea1c676","948":"f4efd39e","982":"ebbbb98b"}[chunkId] + ".chunk.js";
};